/** Interprète les sauts de ligne réels et les séquences littérales `\n` / `\r\n`. */
export function formatGameOverText(text: string): string {
  return text.replace(/\r\n/g, '\n').replace(/\\n/g, '\n');
}

export interface GameOverTextParts {
  /** Premier paragraphe (nom de l'attaque). */
  subtitle: string;
  /** Paragraphes suivants. */
  body: string;
}

/** Sépare le premier paragraphe (sous-titre) du reste du texte game over. */
export function splitGameOverText(text: string): GameOverTextParts {
  const normalized = formatGameOverText(text);
  const splitIndex = normalized.indexOf('\n\n');
  if (splitIndex === -1) {
    return { subtitle: normalized.trim(), body: '' };
  }
  return {
    subtitle: normalized.slice(0, splitIndex).trim(),
    body: normalized.slice(splitIndex + 2).trim(),
  };
}
